import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  button: {
    position: 'relative',
    width: 418,
    height: 70,
    padding: 16,
    textAlign: 'center',
    fontSize: 24,
    transition: '0.2s',
    backgroundSize: '200% auto',
    color: 'white',
    borderRadius: 3,
    border: 'none',
    cursor: 'pointer',
    backgroundImage: 'linear-gradient(to right, #f8b833 0%, #fd4a1a 51%, #f8b833 100%)',
    '&:hover': {
      backgroundPosition: 'right center', /* change the direction of the change here */
    },
  },
  disabled: {
    backgroundImage: 'linear-gradient(to right, #bbbbbb 0%, #878787 51%, #bbbbbb 100%)',
    '&:hover': {
      backgroundPosition: 'left center',
    },
  },
}

const Button = ({ classes, children, className, disabled, ...otherProps }) =>
  <button
    {...otherProps}
    className={classNames({
      [classes.button]: true,
      [className]: true,
      [classes.disabled]: disabled,
    })}
    disabled={disabled}
  >
    <span>{children}</span>
  </button>

export default injectStyles(styles)(Button)



// WEBPACK FOOTER //
// ./src/modules/Button/Button.js